import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';

const MailAddressGenerator = ({ show, onHide }) => {
  const [kunde, setKunde] = useState('');
  const [software, setSoftware] = useState('acronis');
  const [typ, setTyp] = useState('intern');
  const [multitenant, setMultitenant] = useState(false);
  const [generatedEmail, setGeneratedEmail] = useState('');

  // Generate email whenever inputs change
  useEffect(() => {
    if (kunde) {
      let email = `backup+kunde=${kunde}&software=${software}&typ=${typ}`;
      if (multitenant) {
        email += `&multi=true`;
      }
      email += `@lehmann.ch`;
      setGeneratedEmail(email);
    } else {
      let email = 'backup+kunde=&software=acronis&typ=intern';
      if (multitenant) {
        email += '&multi=true';
      }
      email += '@lehmann.ch';
      setGeneratedEmail(email);
    }
  }, [kunde, software, typ, multitenant]);

  // Handle Kunde input - only allow [a-z]
  const handleKundeChange = (e) => {
    const value = e.target.value.toLowerCase();
    // Only allow a-z characters, max 16 characters
    if (/^[a-z]*$/.test(value) && value.length <= 16) {
      setKunde(value);
    }
  };

  // Copy to clipboard
  const handleCopy = () => {
    navigator.clipboard.writeText(generatedEmail);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Mail Address Generator</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Kunde</Form.Label>
            <Form.Control
              type="text"
              value={kunde}
              onChange={handleKundeChange}
              placeholder="Enter customer name (a-z only, max 16 chars)"
              maxLength={16}
            />
            <Form.Text className="text-muted">
              Only lowercase letters (a-z), maximum 16 characters
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Software</Form.Label>
            <Form.Select value={software} onChange={(e) => setSoftware(e.target.value)}>
              <option value="acronis">Acronis</option>
              <option value="synology">Synology</option>
              <option value="veeam">Veeam</option>
              <option value="veeam365">Veeam Data Cloud M365 Backup</option>
              <option value="synologyc2">Synology C2 (mit Agent / nicht Hyperbackup zu C2)</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Typ</Form.Label>
            <Form.Select value={typ} onChange={(e) => setTyp(e.target.value)}>
              <option value="intern">Intern</option>
              <option value="extern">Extern</option>
            </Form.Select>
          </Form.Group>
          <br/>

          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="multitenant-switch"
              label="Multitenant"
              checked={multitenant}
              onChange={() => setMultitenant(!multitenant)}
            />
            <Form.Text className="text-muted">
              Sofern mehrere Kunden mit der gleichen Software / auf dem gleichen NAS gesichert werden und der Job-Name somit relevant ist.
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Generated Email</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                value={generatedEmail}
                readOnly
                style={{ backgroundColor: '#f8f9fa' }}
              />
              <Button variant="outline-secondary" onClick={handleCopy}>
                Copy
              </Button>
            </InputGroup>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MailAddressGenerator;
